(() => {
  const gridSelector = '#product-grid[data-okodoko-stock-sort="true"]';

  const getPageFromUrl = (href) => {
    try {
      const page = Number(new URL(href, window.location.origin).searchParams.get('page'));
      return Number.isFinite(page) && page > 0 ? page : 1;
    } catch (error) {
      return 1;
    }
  };

  const getCurrentPage = () => getPageFromUrl(window.location.href);

  const getTotalPages = () => {
    const pagination = document.querySelector('.pagination');
    if (!pagination) return 1;

    const pages = [getCurrentPage()];
    pagination.querySelectorAll('a[href*="page="]').forEach((link) => {
      pages.push(getPageFromUrl(link.href));
    });
    pagination.querySelectorAll('a, span').forEach((item) => {
      const page = Number(item.textContent.trim());
      if (Number.isFinite(page) && page > 0) pages.push(page);
    });

    return Math.max(...pages);
  };

  const pageUrl = (page) => {
    const url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }
    return url.toString();
  };

  const normaliseItem = (item, index) => {
    const clone = item.cloneNode(true);
    clone.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen');
    clone.style.setProperty('--animation-order', index + 1);
    clone.querySelectorAll('.scroll-trigger, .animate--slide-in, .animate--fade-in, .scroll-trigger--offscreen').forEach((child) => {
      child.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen');
    });
    return clone;
  };

  const sortItems = (items) => [
    ...items.filter((item) => item.dataset.okodokoAvailable === 'true'),
    ...items.filter((item) => item.dataset.okodokoAvailable !== 'true'),
  ];

  const sortCollectionAcrossPages = async () => {
    const grid = document.querySelector(gridSelector);
    if (!grid || grid.dataset.okodokoGlobalSorted === 'true') return;

    const currentPage = getCurrentPage();
    const totalPages = getTotalPages();
    const perPage = Number(grid.dataset.productsPerPage) || grid.children.length || 20;

    if (totalPages <= 1) {
      const sortedItems = sortItems([...grid.children]).map(normaliseItem);
      grid.replaceChildren(...sortedItems);
      grid.dataset.okodokoGlobalSorted = 'true';
      return;
    }

    try {
      const pageItems = Array.from({ length: totalPages }, () => []);
      pageItems[currentPage - 1] = [...grid.children];

      const pagesToFetch = Array.from({ length: totalPages }, (_, index) => index + 1).filter((page) => page !== currentPage);
      const responses = await Promise.all(
        pagesToFetch.map((page) =>
          fetch(pageUrl(page), { credentials: 'same-origin' })
            .then((response) => {
              if (!response.ok) throw new Error(`Page ${page} failed`);
              return response.text();
            })
            .then((html) => ({ page, html }))
        )
      );

      const parser = new DOMParser();
      responses.forEach(({ page, html }) => {
        const doc = parser.parseFromString(html, 'text/html');
        pageItems[page - 1] = [...doc.querySelectorAll(`${gridSelector} > li`)];
      });

      const allItems = pageItems.flat();
      if (!allItems.length) return;

      const start = (currentPage - 1) * perPage;
      const visibleItems = sortItems(allItems)
        .slice(start, start + perPage)
        .map(normaliseItem);

      if (visibleItems.length) {
        grid.replaceChildren(...visibleItems);
        grid.dataset.okodokoGlobalSorted = 'true';
      }
    } catch (error) {
      grid.dataset.okodokoGlobalSorted = 'failed';
    }
  };

  document.addEventListener('DOMContentLoaded', sortCollectionAcrossPages);
})();
